module.exports = __webpack_public_path__ + "static/ice_devil-89684c97138cbd6f5a807de46a1ff961.jpg";